import "./styles.css"

export const Header = () => (
    <div className="header">
        {/* <i class='fab fa-canadian-maple-leaf'></i> */}
        <h1>What's the Weather?</h1>
    </div>
)